/**!
 * Created by Leonardo Cheslacki on 29/01/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './../HelpersController';
import {HelpersTouch} from './../';

let _this = {};

/**
 *
 */
class LayersZoom extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        this.state = {
            original_x: 0,
            original_y: 0,
            original_scale_x: 0,
            original_scale_y: 0,
            touches: {
                one: {
                    clicked_x: 0,
                    clicked_y: 0
                },
                two: {
                    clicked_x: 0,
                    clicked_y: 0
                }
            },
            ui: {
                name: null,
                active: false
            },
            control: {
                speed_x: 0,
                speed_y: 0,
                clicked_x: 0,
                clicked_y: 0
            }
        };

        this.$isDragging = false;
        this.$isDraggingZoom = false;
        this.$isDraggingZoomState = null;
        this.$listenerUpdate = null;
        this.$listenerResetUi = null;

        _this = this;
    };

    /**
     *
     * @returns {*}
     */
    get = () => {
        const {current_name} = this.props;

        return this.main.getState(`_this_${current_name}`);
    };

    /**
     *
     * @returns {string}
     */
    occurrence = () => {
        const {currentFrame} = this.get();

        return this.padWithLeadingZeros(currentFrame, 2);
    };

    /**
     *
     * @returns {string|*}
     */
    getFrame = () => {
        return this.verifyField(this.get(), `occ_frame_${this.occurrence()}`);
    };

    /**
     *
     * @param key
     * @param value
     * @param type
     */
    setControl = (key, value, type = null) => {
        const {control} = this.state;

        if (type === 'increment') {
            control[key] += value;
        } else if (type === 'decrement') {
            control[key] -= value;
        } else if (type === 'times') {
            control[key] *= value;
        } else {
            control[key] = value;
        }
    };

    /**
     *
     * @param type
     */
    setScale = (type) => {
        const
            {occ_sprite} = this.getFrame(),
            {zoom_step, min_scale, max_scale} = _this.props;

        if (type === 'increment') {
            occ_sprite.scaleX = occ_sprite.scaleY = (occ_sprite.scaleX + zoom_step);
        } else if (type === 'decrement') {
            occ_sprite.scaleX = occ_sprite.scaleY = (occ_sprite.scaleX - zoom_step);
        }

        if (occ_sprite.scaleX < min_scale) {
            occ_sprite.scaleX = occ_sprite.scaleY = min_scale;
        } else if (occ_sprite.scaleX > max_scale) {
            occ_sprite.scaleX = occ_sprite.scaleY = max_scale;
        }
    };

    lerp = (v1, v2, friction) => {
        return friction * v1 + (1 - friction) * v2;
    }

    $functions = {
        update: () => {
            const
                {occ_sprite} = _this.getFrame(),
                {
                    window: {stage, canvas},
                    friction,
                    bounds_friction,
                    nudge,
                    check_bounds,
                    check_bounds_when_dragging,
                    check_bounds_when_pressing
                } = _this.props,
                {
                    original_x,
                    original_y,
                    ui: {active, name},
                    control: {clicked_x, clicked_y}
                } = _this.state;

            if (active) {
                switch (name) {
                    case 'btn_more':
                        _this.setScale('increment');
                        break;
                    case 'btn_less':
                        _this.setScale('decrement');
                        break;
                    case 'btn_left':
                        _this.setControl('speed_x', nudge, 'decrement');
                        break;
                    case 'btn_up':
                        _this.setControl('speed_y', nudge, 'decrement');
                        break;
                    case 'btn_right':
                        _this.setControl('speed_x', nudge, 'increment');
                        break;
                    case 'btn_down':
                        _this.setControl('speed_y', nudge, 'increment');
                        break;
                }
            }

            if (_this.$isDraggingZoom) {
                if (_this.$isDraggingZoomState) {
                    _this.setScale('increment');
                } else {
                    _this.setScale('decrement');
                }
            }

            if (_this.$isDragging && !_this.$isDraggingZoom) {
                _this.setControl('speed_x', (stage.mouseX - clicked_x));
                _this.setControl('speed_y', (stage.mouseY - clicked_y));
                _this.setControl('clicked_x', stage.mouseX);
                _this.setControl('clicked_y', stage.mouseY);
            }

            _this.setControl('speed_x', friction, 'times');
            _this.setControl('speed_y', friction, 'times');

            occ_sprite.x += _this.getState('control.speed_x');
            occ_sprite.y += _this.getState('control.speed_y');

            if ((!check_bounds) || (_this.$isDragging && !check_bounds_when_dragging) || (active && !check_bounds_when_pressing)) {
                return;
            }

            let
                bounds = occ_sprite.nominalBounds,
                width = (bounds.width * occ_sprite.scaleX),
                height = (bounds.height * occ_sprite.scaleY),
                left = (occ_sprite.x - width * 0.5),
                right = (occ_sprite.x + width * 0.5),
                top = (occ_sprite.y - height * 0.5),
                bottom = (occ_sprite.y + height * 0.5),
                canvas_width = (canvas.width / stage.scaleX),
                canvas_height = (canvas.height / stage.scaleY);

            if (width >= canvas_width) {
                if (left > 0) {
                    occ_sprite.x = _this.lerp(occ_sprite.x, (width * 0.5), bounds_friction);
                } else if (right < canvas_width) {
                    occ_sprite.x = _this.lerp(occ_sprite.x, canvas_width - width * 0.5, bounds_friction);
                }
            } else {
                occ_sprite.x = _this.lerp(occ_sprite.x, original_x, bounds_friction);
            }

            if (height >= canvas_height) {
                if (top > 0) {
                    occ_sprite.y = _this.lerp(occ_sprite.y, height * 0.5, bounds_friction);
                } else if (bottom < canvas_height) {
                    occ_sprite.y = _this.lerp(occ_sprite.y, canvas_height - height * 0.5, bounds_friction);
                }
            } else {
                occ_sprite.y = _this.lerp(occ_sprite.y, original_y, bounds_friction);
            }
        },

        /**
         *
         * @param event
         */
        touchSprite: (event) => {
            let touches = ((typeof (event.nativeEvent.touches) === 'object') && event.nativeEvent.touches);

            if (touches && touches.length > 1) {
                const {touches: {one, two}} = _this.state;

                let start = 0, end = 0;

                _this.$isDragging = false;
                _this.$isDraggingZoom = true;

                if (one.clicked_x > two.clicked_x) {
                    start = (one.clicked_x - two.clicked_x);
                } else {
                    start = (two.clicked_x - one.clicked_x);
                }

                if (touches[0].clientX > touches[1].clientX) {
                    end = (touches[0].clientX - touches[1].clientX);
                } else {
                    end = (touches[1].clientX - touches[0].clientX);
                }

                _this.$isDraggingZoomState = (start < end);
            }
        },

        /**
         *
         * @param event
         */
        onClick: (event) => {
            const {window: {stage}} = _this.props;

            _this.setControl('clicked_x', stage.mouseX);
            _this.setControl('clicked_y', stage.mouseY);

            _this.$isDragging = true;
            _this.$isDraggingZoom = false;

            let touches = ((typeof (event.nativeEvent.touches) === 'object') && event.nativeEvent.touches);

            if (touches) {
                _this.setState({
                    ..._this.state,
                    touches: {
                        one: {
                            clicked_x: touches[0].clientX
                        },
                        two: {
                            clicked_x: ((typeof (touches[1]) !== 'undefined') ? touches[1].clientX : 0)
                        }
                    }
                });
            }
        },

        /**
         *
         * @param event
         */
        zoomSprite: (event) => {
            let {name} = event.target;

            _this.inArray(['btn_more', 'btn_less'], name) && _this.setState({
                ..._this.state,
                ui: {name: name, active: true}
            });
        },

        /**
         *
         * @param event
         */
        zoomWheelSprite: (event) => {
            _this.setScale((_this.toIntegerOrFloat(event.deltaY * -0.01) > 0) ? 'increment' : 'decrement');
        },

        /**
         *
         * @param event
         */
        moveSprite: (event) => {
            let {name} = event.target;

            _this.inArray(['btn_left', 'btn_up', 'btn_right', 'btn_down'], name) && _this.setState({
                ..._this.state,
                ui: {name: name, active: true}
            });
        },

        /**
         *
         */
        resetUi: () => {
            _this.$isDragging = false;
            _this.$isDraggingZoom = false;
            _this.$isDraggingZoomState = null;
            _this.setState({..._this.state, ui: {name: null, active: false}});
        },

        /**
         *
         */
        resetSprite: () => {
            const
                {occ_sprite} = _this.getFrame(),
                {
                    original_x,
                    original_y,
                    original_scale_x,
                    original_scale_y
                } = _this.state;

            occ_sprite.x = original_x;
            occ_sprite.y = original_y;
            occ_sprite.scaleX = original_scale_x;
            occ_sprite.scaleY = original_scale_y;
        }
    };

    start = () => {
        const
            {window: {stage, canvas, createjs}} = this.props,
            {
                occ_ui: {
                    btn_more,
                    btn_less,
                    btn_left,
                    btn_up,
                    btn_right,
                    btn_down,
                    btn_reset
                }
            } = this.get(),
            {occ_sprite} = this.getFrame();

        this.$listenerUpdate = createjs.Ticker.on('tick', this.$functions.update);

        this.$listenerResetUi = stage.on('stagemouseup', this.$functions.resetUi);

        this.removeListener('pressmove', 'touch-sprite', this.$functions.touchSprite, () => {
            this.addListener(occ_sprite, 'pressmove', 'touch-sprite', this.$functions.touchSprite);
        });

        this.removeListener('mousedown', 'on-click-sprite', this.$functions.onClick, () => {
            this.addListener(occ_sprite, 'mousedown', 'on-click-sprite', this.$functions.onClick);
        });

        this.removeListener('mousedown', 'zoom-sprite-more', this.$functions.zoomSprite, () => {
            this.addListener(btn_more, 'mousedown', 'zoom-sprite-more', this.$functions.zoomSprite);
        });

        this.removeListener('mousedown', 'zoom-sprite-less', this.$functions.zoomSprite, () => {
            this.addListener(btn_less, 'mousedown', 'zoom-sprite-less', this.$functions.zoomSprite);
        });

        this.removeListener('mousedown', 'move-sprite-left', this.$functions.moveSprite, () => {
            this.addListener(btn_left, 'mousedown', 'move-sprite-left', this.$functions.moveSprite);
        });

        this.removeListener('mousedown', 'move-sprite-up', this.$functions.moveSprite, () => {
            this.addListener(btn_up, 'mousedown', 'move-sprite-up', this.$functions.moveSprite);
        });

        this.removeListener('mousedown', 'move-sprite-right', this.$functions.moveSprite, () => {
            this.addListener(btn_right, 'mousedown', 'move-sprite-right', this.$functions.moveSprite);
        });

        this.removeListener('mousedown', 'move-sprite-down', this.$functions.moveSprite, () => {
            this.addListener(btn_down, 'mousedown', 'move-sprite-down', this.$functions.moveSprite);
        });

        this.removeListener('mousedown', 'reset-sprite', this.$functions.resetSprite, () => {
            this.addListener(btn_reset, 'mousedown', 'reset-sprite', this.$functions.resetSprite);
        });

        if (createjs.BrowserDetect.isIOS) {
            this.removeListener('mousewheel', 'zoom-wheel-sprite-ios', this.$functions.zoomWheelSprite, () => {
                this.addListener(canvas, 'mousewheel', 'zoom-wheel-sprite-ios', this.$functions.zoomWheelSprite);
            });
        } else {
            this.removeListener('wheel', 'zoom-wheel-sprite', this.$functions.zoomWheelSprite, () => {
                this.addListener(canvas, 'wheel', 'zoom-wheel-sprite', this.$functions.zoomWheelSprite);
            });
        }
    };

    /**
     *
     */
    first = () => {
        const
            {occ_sprite: {x, y, scaleX, scaleY}} = this.getFrame(),
            {window: {stage, createjs}} = this.props;

        this.setState({
            ...this.state,
            original_x: x,
            original_y: y,
            original_scale_x: scaleX,
            original_scale_y: scaleY
        }, () => {
            stage.enableMouseOver();
            stage.mouseMoveOutside = true;
            createjs.Touch.enable(stage);
            createjs.Ticker.timingMode = createjs.Ticker.RAF;
            stage.on('drawstart', this.start, null, true);
        });
    };

    /**
     *
     */
    destroy = () => {
        const {window: {stage, createjs}} = this.props;
        this.$functions.resetUi();
        this.$functions.resetSprite();
        this.$listenerUpdate && createjs.Ticker.off('tick', this.$listenerUpdate);
        this.$listenerResetUi && stage.off('stagemouseup', this.$listenerResetUi);
        this.start();
    };

    /**
     *
     */
    create = () => {
        const {window, window: {stage}} = this.props;

        let helpersTouch = HelpersTouch({window: window});

        helpersTouch.create();

        this.first();
    };
}

/**
 *
 * @type {{bounds_friction: Requireable<number>, check_bounds: Requireable<boolean>, friction: Requireable<number>, max_scale: Requireable<number>, default_frame: Requireable<string>, check_bounds_when_pressing: Requireable<boolean>, check_bounds_when_dragging: Requireable<boolean>, min_scale: Requireable<number>, name: Requireable<string>, current_name: Requireable<string>, window: Requireable<object>, zoom_step: Requireable<number>, nudge: Requireable<number>}}
 */
const propTypes = {
    name: PropTypes.string,
    default_frame: PropTypes.string,
    current_name: PropTypes.string,
    window: PropTypes.object,
    friction: PropTypes.number,
    bounds_friction: PropTypes.number,
    nudge: PropTypes.number,
    zoom_step: PropTypes.number,
    min_scale: PropTypes.number,
    max_scale: PropTypes.number,
    check_bounds: PropTypes.bool,
    check_bounds_when_dragging: PropTypes.bool,
    check_bounds_when_pressing: PropTypes.bool
};

/**
 *
 * @type {{default: {bounds_friction: number, check_bounds: boolean, friction: number, max_scale: number, default_frame: string, check_bounds_when_pressing: boolean, check_bounds_when_dragging: boolean, min_scale: number, name: string, current_name: null, window: {}, zoom_step: number, nudge: number}}}
 */
const config = {
    default: {
        name: 'zoom',
        default_frame: 'frame00',
        current_name: null,
        window: {},
        friction: 0.85,
        bounds_friction: 0.85,
        nudge: 5,
        zoom_step: 0.01,
        min_scale: 0.1,
        max_scale: 1,
        check_bounds: true,
        check_bounds_when_dragging: false,
        check_bounds_when_pressing: false
    }
};

/**
 *
 * @param _this
 * @returns {function(*): LayersZoom}
 */
export default (_this) => (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'LayersZoom');
    return (new LayersZoom(defaultProps, _this));
};